/**
 * 文章相关接口
 * Filename: article.js
 * Author: GaoYu
 * Time: 2020/7/28 11:41
 */

import request from '@/utils/request'

export function getArticleDetailApi (params) {
  return request({
    url: 'h5/article/getArticleDetails',
    method: 'get',
    params
  })
}

/** 新专题页面 */
export function getArticleSpecialInfoApi (params) {
  return request({
    url: 'api/v5/article-special/get-info',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/article.js